/**
 * Chrome / Google *page* Translate opt-out (RD-I18N-007).
 *
 * TWO systems — do not confuse them:
 *   1. Our app Spanish (`react-intl` + `en.json`/`es.json`, Account language,
 *      company defaultLocale) — UNAFFECTED. This helper never touches catalogs
 *      or LocaleContext's locale resolution.
 *   2. Chrome's "Translate this page?" machine translator — BLOCKED. It
 *      rewrites DOM text (including the CrewVex mark — "Crew" is a real English
 *      word), changes glyph widths mid logo-journey, and can crash React
 *      (ErrorBoundary) during onboarding.
 *
 * Use BOTH `translate="no"` and class `notranslate` — Chrome still honors the
 * class more reliably than the attribute alone.
 */
export const BRAND_NO_TRANSLATE_PROPS = {
  className: 'notranslate',
  translate: 'no',
};

/** Apply the same opt-out on imperative DOM nodes (splash logo journey). */
export function applyBrandNoTranslate(el) {
  if (!el) return;
  el.setAttribute('translate', 'no');
  el.classList.add('notranslate');
}

/** Keep the document root opted out after LocaleContext updates `lang`. */
export function applyDocumentNoTranslate(doc = typeof document !== 'undefined' ? document : null) {
  if (!doc?.documentElement) return;
  applyBrandNoTranslate(doc.documentElement);
}
